var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.855,
    height: 20.847,
    viewBox: "0 0 20.855 20.847",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.523 20.847H1.308a1.3 1.3 0 01-1.3-1.3v-5.214a1.303 1.303 0 112.606 0v3.909h3.909a1.303 1.303 0 010 2.606zm6.515-11.726a1.3 1.3 0 01-.925-2.228L18.628.378a1.3 1.3 0 011.836 1.837L13.949 8.73a1.3 1.3 0 01-.911.391z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.552 7.818a1.3 1.3 0 01-1.3-1.3V2.606H14.34a1.303 1.303 0 110-2.606h5.212a1.3 1.3 0 011.3 1.3v5.212a1.3 1.3 0 01-1.3 1.306zM1.306 20.847a1.3 1.3 0 01-.925-2.228L6.9 12.1a1.3 1.3 0 011.837 1.837l-6.514 6.519a1.3 1.3 0 01-.917.391z"
  })));
}

export default SvgIconExpand;